var _defs, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarsRewards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M.91.999h16.18V17H.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    d: "M0 .037h6v5.962H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stars-rewards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    className: "default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.748 15.161l-3.293-2.487a.757.757 0 00-.912 0l-3.291 2.487 1.27-4.065c.013-.045.032-.175.032-.222a.78.78 0 00-.307-.618L2.9 7.728h4.118a.765.765 0 00.729-.537L9 3.177l1.256 4.017a.76.76 0 00.726.534h4.116l-3.354 2.532a.784.784 0 00-.301.614c0 .051.022.185.036.234l1.269 4.053zm4.144-7.534a.5.5 0 00-.302-.899h-5.432L9.477 1.35a.501.501 0 00-.478-.351h-.001a.5.5 0 00-.477.352L6.845 6.728H1.41a.501.501 0 00-.302.899l4.41 3.331-1.686 5.392a.502.502 0 00.478.649.494.494 0 00.3-.101L9 13.583l4.39 3.316a.501.501 0 00.778-.549l-1.695-5.386 4.42-3.337z",
    id: "Fill-1",
    fill: "#12100B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.909H3.958L3.478.352c-.13-.42-.827-.42-.956 0l-.48 1.557H.5a.5.5 0 00-.304.897l1.268.969-.486 1.577a.499.499 0 00.78.544L3 4.948l1.242.949a.498.498 0 00.78-.546l-.487-1.576 1.269-.969a.5.5 0 00-.304-.897",
    id: "Fill-4",
    fill: "#12100B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.974 13.248a.5.5 0 00-.474-.339h-1.543l-.48-1.557c-.128-.42-.826-.42-.954 0l-.482 1.557H18.5a.498.498 0 00-.303.897l1.267.97-.486 1.576a.5.5 0 00.78.544L21 15.947l1.242.95a.5.5 0 00.78-.545l-.486-1.577 1.267-.969a.501.501 0 00.17-.558",
    id: "Fill-7",
    fill: "#12100B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stars-rewards-selected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    className: "alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.891 6.628a.501.501 0 00-.302-.9h-5.43L9.475.352a.499.499 0 00-.955.001L6.844 5.729H1.41a.5.5 0 00-.302.899l4.41 3.33-1.687 5.393a.501.501 0 00.78.548l4.387-3.315 4.391 3.315a.5.5 0 00.778-.548l-1.696-5.387 4.42-3.336z",
    id: "Fill-1",
    fill: "#12100B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.91H3.958L3.478.353c-.13-.42-.827-.42-.956 0l-.48 1.557H.5a.5.5 0 00-.304.897l1.268.969-.486 1.577a.499.499 0 00.78.544L3 4.949l1.242.949a.497.497 0 00.589.012.498.498 0 00.19-.558l-.486-1.576 1.269-.97A.5.5 0 005.5 1.91",
    id: "Fill-4",
    fill: "#12100B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.974 13.249a.5.5 0 00-.474-.339h-1.543l-.48-1.557c-.128-.42-.826-.42-.954 0l-.482 1.557H18.5a.498.498 0 00-.303.897l1.267.969-.486 1.577a.5.5 0 00.78.544L21 15.948l1.242.949a.5.5 0 00.78-.545l-.486-1.576 1.267-.969a.501.501 0 00.17-.558",
    id: "Fill-7",
    fill: "#12100B"
  }))));
}

SvgStarsRewards.displayName = 'StarsRewards';
export default SvgStarsRewards;